// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Course from "./course.js"
import CourseGroup from "./course-group.js"
import ScoreFactor from "./score-factor.js"

const modelClassData = {
  "attributes": {
    "course_id": {
      "column": {
        "default": null,
        "name": "course_id",
        "null": false,
        "type": null
      },
      "name": "course_id",
      "selected_by_default": null,
      "translated": null
    },
    "course_group_id": {
      "column": {
        "default": null,
        "name": "course_group_id",
        "null": false,
        "type": null
      },
      "name": "course_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "highlight": {
      "column": {
        "default": "0",
        "name": "highlight",
        "null": false,
        "type": "boolean"
      },
      "name": "highlight",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "score_factor_id": {
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": true,
        "type": null
      },
      "name": "score_factor_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "CourseGroupCourse",
  "collectionKey": "course_group_courses",
  "collectionName": "course_group_courses",
  "i18nKey": "course_group_course",
  "camelizedLower": "courseGroupCourse",
  "name": "CourseGroupCourse",
  "nameDasherized": "course-group-course",
  "pluralName": "course_group_courses",
  "ransackable_associations": [
    {
      "className": "CourseGroupCourse::Audit",
      "collectionName": "course_group_course_audits",
      "foreignKey": "course_group_course_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "CourseGroupCourseAudit",
      "through": null
    },
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "CourseGroup",
      "collectionName": "course_groups",
      "foreignKey": "course_group_id",
      "name": "course_group",
      "macro": "belongs_to",
      "resource_name": "CourseGroup",
      "through": null
    },
    {
      "className": "CourseGroupCourse::Audit",
      "collectionName": "course_group_course_audits",
      "foreignKey": "course_group_course_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CourseGroupCourseAudit",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "course_group_id",
      "column": {
        "default": null,
        "name": "course_group_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "course_id",
      "column": {
        "default": null,
        "name": "course_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "highlight",
      "column": {
        "default": "0",
        "name": "highlight",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "score_factor_id",
      "column": {
        "default": null,
        "name": "score_factor_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Course",
      "collectionName": "courses",
      "foreignKey": "course_id",
      "name": "course",
      "macro": "belongs_to",
      "resource_name": "Course",
      "through": null
    },
    {
      "className": "CourseGroup",
      "collectionName": "course_groups",
      "foreignKey": "course_group_id",
      "name": "course_group",
      "macro": "belongs_to",
      "resource_name": "CourseGroup",
      "through": null
    },
    {
      "className": "ScoreFactor",
      "collectionName": "score_factors",
      "foreignKey": "score_factor_id",
      "name": "score_factor",
      "macro": "belongs_to",
      "resource_name": "ScoreFactor",
      "through": null
    }
  ],
  "paramKey": "course_group_course",
  "primaryKey": "id"
}

/** Frontend model for CourseGroupCourse. */
export default class CourseGroupCourse extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  courseId() {
    return this.readAttributeUnderscore("course_id")
  }

  /** @returns {boolean} */
  hasCourseId() {
    const value = this.courseId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  courseGroupId() {
    return this.readAttributeUnderscore("course_group_id")
  }

  /** @returns {boolean} */
  hasCourseGroupId() {
    const value = this.courseGroupId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  highlight() {
    return this.readAttributeUnderscore("highlight")
  }

  /** @returns {boolean} */
  hasHighlight() {
    const value = this.highlight()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  scoreFactorId() {
    return this.readAttributeUnderscore("score_factor_id")
  }

  /** @returns {boolean} */
  hasScoreFactorId() {
    const value = this.scoreFactorId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./course.js").default | null} */
  course() {
    return this._readBelongsToReflection({modelClass: Course, reflectionName: "course"})
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  loadCourse() {
    if (!("courseId" in this)) throw new Error("Foreign key method wasn't defined: courseId")

    const id = this.courseId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "course",
        model: this,
        modelClass: Course
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./course.js").default | null>} */
  ensureCourseLoaded() {
    return this.ensureAssociationLoaded("course")
  }

  /** @returns {import("./course-group.js").default | null} */
  courseGroup() {
    return this._readBelongsToReflection({modelClass: CourseGroup, reflectionName: "course_group"})
  }

  /** @returns {Promise<import("./course-group.js").default | null>} */
  loadCourseGroup() {
    if (!("courseGroupId" in this)) throw new Error("Foreign key method wasn't defined: courseGroupId")

    const id = this.courseGroupId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "course_group",
        model: this,
        modelClass: CourseGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./course-group.js").default | null>} */
  ensureCourseGroupLoaded() {
    return this.ensureAssociationLoaded("course_group")
  }

  /** @returns {import("./score-factor.js").default | null} */
  scoreFactor() {
    return this._readBelongsToReflection({modelClass: ScoreFactor, reflectionName: "score_factor"})
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  loadScoreFactor() {
    if (!("scoreFactorId" in this)) throw new Error("Foreign key method wasn't defined: scoreFactorId")

    const id = this.scoreFactorId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "score_factor",
        model: this,
        modelClass: ScoreFactor
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./score-factor.js").default | null>} */
  ensureScoreFactorLoaded() {
    return this.ensureAssociationLoaded("score_factor")
  }
}
